import { render, staticRenderFns } from "./TempTitle.vue?vue&type=template&id=487eadba&scoped=true"
import script from "./TempTitle.vue?vue&type=script&lang=js"
export * from "./TempTitle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "487eadba",
  null
  
)

export default component.exports